export default function buildTooltipData({
  image, name, description, enhancementsDescription, useEventId,
}) {
  return {
    image,
    name,
    description,
    secondaryDescription: useEventId ? 'Click on this item in your inventory to use it.' : enhancementsDescription,
  };
}